import { Injectable } from '@angular/core';

//Import users

//Import Obsevable to make service asynchronous
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { forkJoin } from "rxjs/observable/forkJoin";

//Import for messages
import { MessageService } from 'services/message.service'
import { Http, Headers, RequestOptions } from '@angular/http';

import { AuthService } from 'services/auth.service';

import * as _ from 'underscore';
import { PagerService } from 'services/index';

import { Pager } from '../../../pager';

@Injectable()
export class AnswerService {
	domain = this.authService.domain;
  
  constructor(
  	private messageService: MessageService,
  	private http: Http,
    private authService: AuthService,
    private pagerService:　PagerService
  ) { }

  apiAnswer(studentId, courseCode, questionId) {
    const url = this.domain + 'question/studentGetQuestion/' + courseCode + "/" + studentId + '/' + questionId;

    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  apiPostAnswer(body) {
  	const url = this.domain + 'answer_history';
  	return this.http.post(url, body, this.authService.options).map(res => res.json());
  }

  apiPostDraftAnswer(body) {
  	const url = this.domain + 'draft_answer';
  	return this.http.post(url, body, this.authService.options).map(res => res.json());
  }

  apiPutFeedback(body, questionId, courseCode) {
    const url = this.domain + 'answer_history/feedback/' + questionId + "/" + courseCode;

    return this.http.put(url, body, this.authService.options).map(res => res.json());
  }

  getAnswer(studentId, courseCode, questionId) {
    return new Promise<any>((resolve, reject) => {
      this.apiAnswer(studentId, courseCode, questionId).subscribe( res => {
        resolve(res);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  studentSaveAnswer(data) {
  	return new Promise<any>((resolve, reject) => {
      this.apiPostAnswer(data).subscribe( res => {
        resolve(res);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  studentSaveDraftAnswer(data) {
  	return new Promise<any>((resolve, reject) => {
      this.apiPostDraftAnswer(data).subscribe( res => {
        resolve(res);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  updateFeedback(data, questionId, courseCode) {
    return new Promise<any>((resolve, reject) => {
      this.apiPutFeedback(data, questionId, courseCode).subscribe( res => {
        resolve(res);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/component/student/answer/answer.service.ts